import SectionHeader from './SectionHeader'
import NewsLetterBtn from './NewsLetterBtn'

const NewsLetter = () => {
  return (
    <div className="flex flex-col lg:flex-row md:items-center max-w-full lg:items-end justify-between gap-10 md:gap-14 lg:px-0">
      <SectionHeader
        subtitle="Sign up to our newsletter"
        description="Stay up to date with our newsletters, announcements, and articles."
        subTitleStyle="text-[22px] md:text-2xl md:text-center text-black dark:text-white font-medium lg:text-left text-center whitespace-nowrap text-start"
        descriptionStyle="text-[13px] md:text-base leading-[15.25px] dark:text-white lg:text-left text-center text-start"
      />
      <NewsLetterBtn />
    </div>
  )
}

export default NewsLetter
